import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, XCircle, Sparkles } from "lucide-react";

export default function StepFeedback({ result }) {
  if (!result) return null;
  const { score, is_correct, ai_feedback, correct_summary } = result;
  const color = score >= 80 ? "emerald" : score >= 50 ? "amber" : "red";
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
      className={`mt-4 rounded-xl p-4 border ${color === "emerald" ? "border-emerald-400/30 bg-emerald-400/5" : color === "amber" ? "border-amber-400/30 bg-amber-400/5" : "border-red-400/30 bg-red-400/5"}`}
      data-testid="sim-step-feedback"
    >
      <div className="flex items-center gap-2 mb-2">
        {is_correct ? <CheckCircle2 className="w-4 h-4 text-emerald-400" /> : <XCircle className="w-4 h-4 text-red-400" />}
        <span className="text-sm font-bold text-white" data-testid="sim-step-score">Score: {score}/100</span>
        <span className="ml-auto flex items-center gap-1 text-[10px] font-bold uppercase text-indigo-400"><Sparkles className="w-3 h-3" /> AI Feedback</span>
      </div>
      <p className="text-sm text-slate-300 leading-relaxed" data-testid="sim-step-ai-feedback">{ai_feedback}</p>
      {correct_summary && (
        <p className="text-xs text-slate-400 mt-2 pt-2 border-t border-white/5">
          <span className="font-semibold text-slate-400">Ideal approach:</span> {correct_summary}
        </p>
      )}
    </motion.div>
  );
}
